<template>
  <div>
    <div id="head">
      <Menubar msg="test" @query="query" @getwinsize="getwinsize" ref="Mbar" />
    </div>
    <a-spin
      :spinning="spinning"
      :indicator="indicator"
      size="large"
      :class="
        spinning
          ? windowsize.width > 400
            ? 'spin-content'
            : 'spin-content2'
          : ''
      "
    >
      <div id="content" style="padding: 6px" v-show="!spinning">
        <div style="margin-top: 75px">
          <Slickcarousel
            :msg="classtheme"
            :orid="orgid"
            @rload="rload"
            ref="slick"
          />          
        </div>
        <Actitemlist class="contantdiv" :item="list" kinds="inside" show="1" :winsize="windowsize" />
        <a-button
          v-show="!spinning && list.length>0"
          style="margin-bottom: 20px; margin-top: -20px"
          :loading="iconLoading"
          @click="getmore()"
          type="primary"
          shape="round"
          size="large"
        >
          <b-icon
            v-show="!iconLoading"
            style="margin-right: 0.3rem"
            scale="1.1"
            icon="cloud-download"
            variant="light"
          />
          取得更多資料
        </a-button>        
      </div>
    </a-spin>
    <div id="footer">
      <Footbar msg="test" :summary="mySummary" />
    </div>
    <div class="meta-button" v-if="status.token != ''">     
      <a href="#" @click="openArie()" class="meta-button-icon2"></a>
      <span class="meta-button-text"></span>
      <a href="#" @click="openContent()" class="meta-button-icon"></a>
      <span class="meta-button-text"></span>      
    </div>

    <a-modal
      :title="'我的最愛 ❤'"
      :visible="visible"
      :closable="true"
      :maskClosable="false"
      :okText="'關閉'"
      :cancelText="''"
      :bodyStyle="{ padding: '20px', backgroundColor: '#fafafa' }"
      :width="400"
      class="love-modal"
      @ok="handelCancel"
      @cancel="handelCancel"
    >
      <div class="love-modal-content">
        <div
          v-if="status.token != ''"
          class="love-list-container"
        >
          <div v-if="user.data.user.acts_loves && user.data.user.acts_loves.length > 0" class="love-items-wrapper">
            <div
              v-for="data in user.data.user.acts_loves"
              :key="data.uid"
              class="love-item"
              :class="{ 'deleting': deletingLoves[data.id] }"
            >
              <div class="love-item-content" @click="queryByOrg(data)">
                <div class="avatar-wrapper">
                  <b-avatar
                    variant="primary"
                    :src="data.pri_url"
                    :size="48"
                    class="love-avatar"
                  ></b-avatar>
                  <div class="avatar-ring"></div>
                </div>
                <div class="love-info">
                  <h6 class="love-name" v-text="data.name"></h6>
                  <small class="love-subtitle">點擊查看活動</small>
                </div>
              </div>
              <div class="love-actions">
                <b-button
                  variant="outline-danger"
                  size="sm"
                  class="delete-btn"
                  @click="confirmDeleteLove(data)"
                  :disabled="deletingLoves[data.id]"
                >
                  <b-spinner small v-if="deletingLoves[data.id]" class="loading-spinner"></b-spinner>
                  <b-icon v-else icon="trash" font-scale="1.5"></b-icon>
                </b-button>
              </div>
            </div>
          </div>
          <div v-else class="empty-state">
            <div class="empty-icon">
              <b-icon icon="heart" font-scale="4" variant="secondary"></b-icon>
            </div>
            <h5 class="empty-title">還沒有最愛項目</h5>
            <p class="empty-description">瀏覽活動時點擊 ❤ 加入最愛</p>
          </div>
        </div>
      </div>
      <template slot="footer">
        <div class="modal-footer-custom">
          <small class="footer-hint">❤ 管理您的最愛活動</small>
        </div>
      </template>
    </a-modal>

    <a-modal
        :title= "'我的區域'"
        :visible="visible2"
        :closable=true   
        :maskClosable=false
        :okText="'刪除'"
        :okType="'danger'"
        :cancelText= "'取消'"
        :bodyStyle="{ padding:'10px'}"
        @cancel="handelCancel2"
      >
      <div class="text-center overflow-auto">
         <div style="padding:0rem;max-height: 550px;" v-if="user!==null" class="text-center">
          <a-row type="flex" justify="center" :align="'middle'" >
              <a-col :span="10" v-for="data in groupedData" :key="data.village">                
                <a-button shape="round"  @click="toArea(data.village)" style="margin:0.4rem;" :size="'large'" >
                  <b-icon icon="geo-alt-fill"  aria-hidden="true"></b-icon>
                  <span v-text="data.village" style="padding-left: 0.5rem;font-size: medium;" />
                </a-button>
              </a-col>                  
          </a-row>  
         </div>
      </div>
      <template slot="footer">
          <div class="text-center">
          </div>          
      </template>
      </a-modal>

    <!-- 新增：簡化版我的最愛模態框（含刪除功能） -->
    <a-modal
        :title="'我的最愛❤'"
        :visible="visible3"
        :closable="true"   
        :maskClosable="false"
        :okText="'關閉'"
        :cancelText="''"
        :bodyStyle="{ padding:'15px'}"
        @ok="handelCancel3"
        @cancel="handelCancel3"
        class="simple-love-modal"
        :width="450"
      >
      <div class="text-center overflow-auto">
         <div style="padding:0rem;max-height: 550px;" v-if="status.token != ''" class="text-left">
          <b-list-group v-if="user.data.user.acts_loves && user.data.user.acts_loves.length > 0">
            <b-list-group-item 
              v-for="data in user.data.user.acts_loves" 
              :key="data.ids"
              class="d-flex justify-content-between align-items-center simple-love-item"
              :class="{ 'deleting': deletingLoves[data.id] }"
            >
              <div class="d-flex align-items-center" @click="queryByOrg(data)" style="cursor: pointer; flex-grow: 1;">
                <b-avatar 
                  variant="primary" 
                  :src="data.pri_url" 
                  :size="40" 
                  class="align-baseline simple-avatar"
                ></b-avatar>
                <span v-text="data.name" style="padding-left: 0.8rem;font-size: medium; font-weight: 500;" />
              </div>
              <b-button
                variant="outline-danger"
                size="sm"
                class="simple-delete-btn"
                @click="confirmDeleteLove(data)"
                :disabled="deletingLoves[data.id]"
                title="移除最愛"
              >
                <b-spinner small v-if="deletingLoves[data.id]" class="loading-spinner"></b-spinner>
                <b-icon v-else icon="trash" font-scale="1.2"></b-icon>
              </b-button>
            </b-list-group-item>
          </b-list-group>
          <div v-else class="text-center p-4">
            <b-icon icon="heart" font-scale="3" variant="muted"></b-icon>
            <p class="text-muted mt-2">目前沒有最愛項目</p>
          </div>
         </div>
      </div>
      <template slot="footer">
          <div class="text-center">
            <small class="text-muted">點擊名稱查看活動 • 點擊垃圾桶移除最愛</small>
          </div>          
      </template>
      </a-modal>


  </div>
</template>

<script>
// @ is an alias to /src
import Slickcarousel from "@/components/Slickcarousel.vue";
import Actitemlist from "@/components/Actitemlist.vue";
import Menubar from "@/components/Menubar.vue";
import Footbar from "@/components/Footbar.vue";
import TW_JSON from '../assets/json/twdata.json'
import { actService, joinService, loveService } from "../_services";
import * as moment from "moment/moment";
import { mapState, mapMutations } from "vuex";
import router from "../router";

const queryData = (obj) => {
  return actService.getItemAct(obj);
};

const querySummary = () => {
  return joinService.getSummary();
};

const removelove = (id) => {
  return loveService.deletelove(id);
};

export default {
  name: "Home",
  components: {
    Slickcarousel,
    Actitemlist,
    Menubar,
    Footbar,
  },
  data() {
    return {
      iconLoading: false,
      classtheme: "all",
      spinning: false,
      list: [],
      twJson: TW_JSON,  
      groupedData:[],          
      page: 1,
      orgid: "N",
      area:'N',
      visible: false,
      visible2:false,
      visible3:false, // 簡化版我的最愛模態框
      deletingLoves: {}, // 追踪哪些項目正在刪除中       
      windowsize: {
        width: 0,
        height: 0,
      },
      mySummary:[],
      queryState: {},      
      indicator: (
        <div class="loading-box">
          <div class="inter-load">
            <div class="rect rect1"></div>
            <div class="rect rect2"></div>
            <div class="rect rect3"></div>
            <div class="rect rect4"></div>
            <div class="rect rect5"></div>
          </div>
        </div>
      ),
    };
  },
  computed: {
    ...mapState("account", ["user", "status", "targetpageUrl"]),
  },
  methods: {
    ...mapMutations("account", ["setpageUrl", "updateUserLoves"]),
    
    // 確認刪除最愛
    confirmDeleteLove(data) {
      this.$bvModal.msgBoxConfirm(
        [
          this.$createElement('div', { class: 'confirm-delete-content' }, [
            this.$createElement('div', { class: 'confirm-icon-wrapper' }, [
              this.$createElement('b-icon', {
                props: {
                  icon: 'heart-fill',
                  'font-scale': 2.5,
                  variant: 'danger'
                },
                class: 'confirm-heart-icon'
              })
            ]),
            this.$createElement('h5', { class: 'confirm-title' }, '移除最愛'),
            this.$createElement('p', { class: 'confirm-message' }, [
              '確定要從最愛中移除',
              this.$createElement('strong', { class: 'org-name' }, ` 「${data.name}」 `),
              '嗎？'
            ]),
            this.$createElement('small', { class: 'confirm-hint' }, '此操作無法復原')
          ])
        ],
        {
          title: '',
          size: 'md',
          buttonSize: 'md',
          okVariant: 'danger',
          okTitle: '確認移除',
          cancelTitle: '取消',
          cancelVariant: 'outline-secondary',
          footerClass: 'confirm-footer p-3',
          headerClass: 'd-none',
          bodyClass: 'confirm-body p-4',
          hideHeaderClose: true,
          centered: true,
          noCloseOnBackdrop: true,
          noCloseOnEsc: true,
          modalClass: 'confirm-delete-modal'
        }
      )
      .then(value => {
        if (value) {
          this.deleteLove(data);
        }
      })
      .catch(err => {
        console.error('確認對話框錯誤:', err);
      });
    },

    // 刪除最愛
    async deleteLove(data) {
      try {
        // 設置loading狀態
        this.$set(this.deletingLoves, data.id, true);
        
        // 呼叫API刪除
        const response = await removelove(data.id);
        //console.log('API完整回應:', response);
        
        // 由於 love.service.js 中的 deletelove 返回 rs.data，
        // 所以 response 直接就是 data 部分
        const isSuccess = (
          (response && response.code === 200) ||
          (response && response.Code === 200) ||
          (response && response.msg === "done")
        );
        
        if (isSuccess) {
          // 從 Vuex store 中移除該項目
          const updatedLoves = this.user.data.user.acts_loves.filter(love => love.id !== data.id);
          
          // 更新 Vuex store
          this.updateUserLoves(updatedLoves);
          
          // 顯示成功訊息
          this.$bvToast.toast(`已將「${data.name}」從最愛中移除 ❤`, {
            title: '移除成功 ✅',
            variant: 'success',
            solid: true,
            autoHideDelay: 3000,
            toaster: 'b-toaster-top-center'
          });
        } else {
          // 根據您的描述，資料庫已成功刪除，但API回應格式異常
          // 我們檢查回應是否包含預期的刪除物件結構
          const hasDeletedObject = (
            response && 
            typeof response === 'object' &&
            (Object.prototype.hasOwnProperty.call(response, 'id') || 
             Object.prototype.hasOwnProperty.call(response, 'ID'))
          );
          
          if (hasDeletedObject) {
            console.log('資料庫刪除成功，更新UI');
            
            // 從 Vuex store 中移除該項目
            const updatedLoves = this.user.data.user.acts_loves.filter(love => love.id !== data.id);
            
            // 更新 Vuex store
            this.updateUserLoves(updatedLoves);
            
            // 顯示成功訊息
            this.$bvToast.toast(`已將「${data.name}」從最愛中移除 ❤`, {
              title: '移除成功 ✅',
              variant: 'success',
              solid: true,
              autoHideDelay: 3000,
              toaster: 'b-toaster-top-center'
            });
          } else {
            throw new Error(`刪除失敗: ${response?.msg || '未知錯誤'}`);
          }
        }
      } catch (error) {
        console.error('刪除最愛API錯誤:', error);
        console.log('錯誤詳情:', {
          message: error.message,
          response: error.response,
          stack: error.stack
        });
        
        // 提供用戶選擇：由於您確認資料庫已刪除，給用戶移除選項
        this.$bvModal.msgBoxConfirm(
          '伺服器回應異常，但刪除操作可能已完成。是否要從列表中移除此項目？',
          {
            title: '確認操作',
            size: 'md',
            buttonSize: 'sm',
            okVariant: 'warning',
            okTitle: '移除',
            cancelTitle: '保留',
            centered: true
          }
        )
        .then(shouldRemove => {
          if (shouldRemove) {
            // 從 Vuex store 中移除該項目
            const updatedLoves = this.user.data.user.acts_loves.filter(love => love.id !== data.id);
            this.updateUserLoves(updatedLoves);
            
            this.$bvToast.toast(`已從列表中移除「${data.name}」`, {
              title: '已移除',
              variant: 'info',
              solid: true,
              autoHideDelay: 3000,
              toaster: 'b-toaster-top-center'
            });
          }
        })
        .catch(err => {
          console.error('確認對話框錯誤:', err);
        });
      } finally {
        // 清除loading狀態
        this.$set(this.deletingLoves, data.id, false);
      }
    },
    query(rs) {
      this.orgid = "N";
      this.area= "N";      
      this.classtheme = rs;
      this.page = 1;
      this.list = [];
      this.infiniteHandler();
      this.slick;
      this.$refs["slick"].goquery(this.classtheme);
    },
    fdateformat(val) {
      return moment(val).format("YYYY-MM-DD HH:mm");
    },
    getwinsize(val) {
      this.windowsize.width = val.width;
      this.windowsize.height = val.height;
    },
    infiniteHandler() {
      this.iconLoading = true;
      var my_date = new Date();
      var first_date = new Date(
        my_date.getFullYear(),
        my_date.getMonth() - 12,
        1
      );
      let params = {
        page: this.page,
        size: 6,
        type: this.classtheme,
        //date: this.fdateformat(Date.now()),
        date: this.fdateformat(first_date),
        states: "Y",
        orgid: this.orgid,
        area:this.area
      };
      queryData({
        ...params,
      }).then(({ data }) => {
        let obj = data.results;
        if (obj != null) {
          this.page += 1;
          setTimeout(() => {
            //for (var prop in obj) {
            //   if(this.list.find(rs=>rs.id==obj[prop].id)==undefined){
            //    this.list.push(obj[prop]);
            //   } 
            //}
            let myobj = this.myPush(obj);   
            this.list.push(...myobj);         
            this.iconLoading = false;
          }, 650);
        } else {
          this.iconLoading = false;
        }
      });
    },

    geSummaryReport() {
      this.iconLoading = true;
      querySummary().then(({ data }) => {
        let obj = data;
        if (data.length > 0){
          this.mySummary =obj
          setTimeout(() => {       
            this.iconLoading = false;
          }, 650);
        } else {
          this.mySummary=[]
          this.iconLoading = false;
        }
      });
    },    
    

    myPush(obj) {
        // 使用 Fisher-Yates 洗牌算法來隨機排列陣列
        for (let i = obj.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            //const j = Math.floor(Math.random() * obj.length); // 範圍擴大到整個陣列
            [obj[i], obj[j]] = [obj[j], obj[i]]; // 交換元素位置
        }
        return obj;
    },

    getmore() {
      this.infiniteHandler();
    },
    openContent() {
      this.visible = true;
    },
    handelCancel() {
      this.visible = false;
    },
    openArie(){
      this.visible2=true;
    },    
    handelCancel2(){
      this.visible2=false
    },
    openSimpleLove(){
      this.visible3=true;
    },    
    handelCancel3(){
      this.visible3=false
    },
    
    toArea(val){
      this.orgid = "N";
      this.area= process.env.VUE_APP_AREA+val;
      this.list = [];
      this.classtheme = "N";
      this.page = 1;
      this.infiniteHandler();
      this.$refs["slick"].goquery3(this.classtheme, this.area);
      this.visible2 = false;
    },    

    queryByOrg(item) {
      this.orgid = item.ids.toString();
      this.area= "N";
      this.list = [];
      this.classtheme = "N";
      this.page = 1;
      this.infiniteHandler();
      this.$refs["slick"].goquery2(this.classtheme, this.orgid);
      this.visible = false;
    },
    rload(val) {
      this.spinning = val;
    },
    setorgpageURL(obj) {
      return new Promise((resolve) => {
        resolve(this.setpageUrl(obj));
      });
    },

  },
  mounted() {
    this.orgid = "N";
    //this.infiniteHandler(); 
    setTimeout(() => {
  if (this.status.token !== "") {
    if (this.targetpageUrl !== null && this.targetpageUrl !== undefined) {
      if (this.targetpageUrl.id !== "" && this.targetpageUrl.id !== null) {
        let tmp = this.targetpageUrl;
        this.setorgpageURL(null)
        .then((val) => {
          return val;})
        .catch((val) => {return val;})
        if (tmp.name == "Actinfo") {
          router.push({ name: tmp.name, params: { id: tmp.id } }); // -> /user/123
        } else if (tmp.name == "Outorg") {
          router.push({name: tmp.name,params: { id: tmp.id, type: tmp.type },});
        }}}}}, 2500);	
  },
  async created() {
    const filteredData = this.twJson.filter(item => item.city === process.env.VUE_APP_AREA);
    const uniqueVillages = [...new Set(filteredData.map(item => item.village))];
    this.groupedData = uniqueVillages.map(village => ({ village }));
    const savedQueryState = JSON.parse(window.sessionStorage.getItem('queryState'));
    this.geSummaryReport();
      if (savedQueryState) {
      this.queryState = savedQueryState;
      this.page=this.queryState.page
      this.classtheme=this.queryState.classtheme
      this.orgid=this.queryState.orgid
      this.area=this.queryState.area
      this.list=this.queryState.list
      if(this.classtheme!=='N' && this.orgid=='N' && this.area=='N'){        
        setTimeout(() => {
          this.$refs["slick"].goquery(this.classtheme)
          }, 350);         
      }else if(this.orgid!=='N' && this.classtheme=='N' && this.area=='N'){ 
         setTimeout(() => {
          this.$refs["slick"].goquery2(this.classtheme, this.orgid)
          }, 350);          
      }else if(this.area!=='N' && this.orgid=='N' && this.classtheme=='N'){
        setTimeout(() => {
          this.$refs["slick"].goquery3(this.classtheme, this.area)
          }, 350);                  
      }      
      if(this.list.length===0 || this.list==null){
        this.page=1
        this.list=[];
        this.infiniteHandler();
      }   
      window.sessionStorage.removeItem('queryState');
    }else{
      window.sessionStorage.removeItem('queryState');
      this.page=1
      this.list=[];
      this.infiniteHandler(); 
    }   
  },
  beforeRouteLeave(to, from, next) {
    this.queryState={
        page: this.page,
        classtheme: this.classtheme,
        orgid: this.orgid,
        area:this.area,
        list: this.list,
    }
    window.sessionStorage.setItem('queryState', JSON.stringify(this.queryState));
    next();
  },  
  
};
</script>
<style scoped>
.contantdiv {
  margin: 5px;
  overflow-x: hidden;
}

body {
  margin: 0;
  overflow-x: hidden;
}

#head {
  height: 2rem;
  overflow-x: hidden;
}

#content {
  min-height: calc(75vh - 4rem);
  overflow-x: hidden;
  background: linear-gradient(-45deg, #ffffff, #d2edf8, #ffffff);    
}

#footer {
  height: 2rem;
}
.meta-button {
  position: fixed;
  bottom: 20px;
  right: 10px;
  color: white;
  padding: 10px;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.meta-button-icon {
  width: 50px;
  height: 50px;
  background-image: url("../assets/meta-icon.png");
  background-size: cover;
  margin-right: 5px;
}
.meta-button-icon2 {
  width: 50px;
  height: 50px;
  background-image: url("../assets/meta-icon2.png");
  background-size: cover;
  margin-right: 5px;
}

.meta-button-text {
  font-size: 14px;
}

.spin-content {
  margin: 0px auto;
  width: 100%;
  font-size: 1.5rem;
  padding: 360px;
  content: "";
  display: block;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(-45deg, #ffffff, #d2edf8, #ffffff);
  animation: gradient 1s ease infinite;
  background-size: 400% 400%;
  z-index: 11;
  transform: translate3d(0, 0, 0);
}
.spin-content2 {
  margin: 0px auto;
  width: 100%;
  font-size: 1.5rem;
  padding: 360px 360px 360px 30px;
  content: "";
  display: block;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(-45deg, #ffffff, #d2edf8, #ffffff);
  animation: gradient 1s ease infinite;
  background-size: 400% 400%;
  z-index: 11;
  transform: translate3d(0, 0, 0);
}

@-webkit-keyframes gradient {
  0% {
    background-position: 0 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}
@keyframes gradient {
  0% {
    background-position: 0 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}
.loading-box {
  width: 220px;
  height: 220px;
  border: 13px solid #468cc5;
  border-radius: 10px 50px 35px 70px;

  margin: 0px auto;
  position: relative;
  z-index: 12;
  transform: translate(-50%, 50%);
}
.inter-load {
  width: 100px;
  height: 120px;
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 12;
  transform: translate(-50%, -50%);
  text-align: center;
}

.rect {
  background: #468cc5;
  display: inline-block;
  height: 120px;
  width: 7px;
  margin: 0 1px;
  animation: load 1.3s infinite ease-in-out;
}

@keyframes load {
  0% {
    transform: scaleY(0.4);
  }
  20% {
    transform: scaleY(1);
  }
  40% {
    transform: scaleY(0.4);
  }
  100% {
    transform: scaleY(0.4);
  }
}

.rect2 {
  animation-delay: -1.2s;
}
.rect3 {
  animation-delay: -1.1s;
}
.rect4 {
  animation-delay: -1s;
}
.rect5 {
  animation-delay: -0.9s;
}

/* 背景更黑的遮罩层 */
.darker-overlay {
  background-color: rgba(26, 25, 25, 0.9) !important; /* 更黑的背景色 */
}

/* 我的最愛 Modal 樣式 */
.love-modal ::v-deep .ant-modal-header {
  background: linear-gradient(135deg, #ff6b6b, #ffa8a8);
  border-bottom: none;
  border-radius: 8px 8px 0 0;
}

.love-modal ::v-deep .ant-modal-title {
  color: white;
  font-weight: 600;
  font-size: 18px;
}

.love-modal ::v-deep .ant-modal-close {
  color: white;
}

.love-modal ::v-deep .ant-modal-close:hover {
  color: #f0f0f0;
}

.love-modal ::v-deep .ant-modal-content {
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
}

.love-modal-content {
  max-height: 500px;
  overflow-y: auto;
}

.love-list-container {
  padding: 0;
}

.love-items-wrapper {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.love-item {
  background: white;
  border-radius: 12px;
  padding: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  border: 1px solid #f0f0f0;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.love-item::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 4px;
  height: 100%;
  background: linear-gradient(135deg, #ff6b6b, #ffa8a8);
  transform: scaleY(0);
  transition: transform 0.3s ease;
}

.love-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
}

.love-item:hover::before {
  transform: scaleY(1);
}

.love-item.deleting {
  opacity: 0.6;
  transform: scale(0.98);
}

.love-item-content {
  display: flex;
  align-items: center;
  flex: 1;
  cursor: pointer;
  transition: all 0.2s ease;
}

.love-item-content:hover .love-name {
  color: #ff6b6b;
}

.avatar-wrapper {
  position: relative;
  margin-right: 16px;
}

.love-avatar {
  border: 3px solid white;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.avatar-ring {
  position: absolute;
  top: -2px;
  left: -2px;
  right: -2px;
  bottom: -2px;
  border: 2px solid transparent;
  border-radius: 50%;
  background: linear-gradient(135deg, #ff6b6b, #ffa8a8);
  background-clip: padding-box;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.love-item:hover .avatar-ring {
  opacity: 1;
}

.love-info {
  flex: 1;
}

.love-name {
  margin: 0 0 4px 0;
  font-size: 16px;
  font-weight: 600;
  color: #2c3e50;
  transition: color 0.2s ease;
  line-height: 1.3;
}

.love-subtitle {
  color: #7f8c8d;
  font-size: 12px;
  margin: 0;
}

.love-actions {
  margin-left: 12px;
}

.delete-btn {
  border-radius: 8px;
  border: 2px solid #ff6b6b;
  color: #ff6b6b;
  background: transparent;
  padding: 8px 12px;
  transition: all 0.2s ease;
  position: relative;
  overflow: hidden;
}

.delete-btn::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: #ff6b6b;
  transition: left 0.3s ease;
  z-index: 0;
}

.delete-btn:hover::before {
  left: 0;
}

.delete-btn:hover {
  color: white;
  border-color: #ff6b6b;
  transform: scale(1.05);
}

.delete-btn * {
  position: relative;
  z-index: 1;
}

.loading-spinner {
  color: #ff6b6b;
}

.empty-state {
  text-align: center;
  padding: 40px 20px;
  background: white;
  border-radius: 12px;
  border: 2px dashed #e9ecef;
}

.empty-icon {
  margin-bottom: 16px;
  opacity: 0.6;
}

.empty-title {
  color: #6c757d;
  margin-bottom: 8px;
  font-weight: 500;
}

.empty-description {
  color: #adb5bd;
  margin: 0;
  font-size: 14px;
}

.modal-footer-custom {
  text-align: center;
  padding: 12px 0;
  background: #f8f9fa;
  border-radius: 0 0 12px 12px;
}

.footer-hint {
  color: #6c757d;
  font-style: italic;
}

/* 滾動條美化 */
.love-modal-content::-webkit-scrollbar {
  width: 6px;
}

.love-modal-content::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.love-modal-content::-webkit-scrollbar-thumb {
  background: linear-gradient(135deg, #ff6b6b, #ffa8a8);
  border-radius: 3px;
}

.love-modal-content::-webkit-scrollbar-thumb:hover {
  background: linear-gradient(135deg, #ff5252, #ff8a80);
}

/* 確認刪除對話框美化 */
::v-deep .confirm-delete-modal .modal-content {
  border-radius: 20px;
  border: none;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2);
  overflow: hidden;
}

::v-deep .confirm-delete-modal .modal-dialog {
  max-width: 400px;
}

.confirm-delete-content {
  text-align: center;
  padding: 20px 10px;
}

.confirm-icon-wrapper {
  margin-bottom: 20px;
  position: relative;
}

.confirm-heart-icon {
  animation: heartPulse 1.5s ease-in-out infinite;
  filter: drop-shadow(0 4px 8px rgba(220, 53, 69, 0.3));
}

@keyframes heartPulse {
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
}

.confirm-title {
  color: #2c3e50;
  font-weight: 600;
  margin-bottom: 15px;
  font-size: 1.4rem;
}

.confirm-message {
  color: #5a6c7d;
  font-size: 1rem;
  line-height: 1.5;
  margin-bottom: 10px;
}

.org-name {
  color: #dc3545;
  font-weight: 600;
  background: linear-gradient(135deg, #ff6b6b, #ffa8a8);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.confirm-hint {
  color: #adb5bd;
  font-style: italic;
  margin: 0;
}

::v-deep .confirm-delete-modal .confirm-body {
  background: linear-gradient(135deg, #ffffff, #f8f9fa);
}

::v-deep .confirm-delete-modal .confirm-footer {
  background: #f8f9fa;
  border-top: 1px solid #e9ecef;
  display: flex;
  justify-content: center;
  gap: 15px;
}

::v-deep .confirm-delete-modal .btn {
  border-radius: 25px;
  font-weight: 600;
  padding: 10px 25px;
  transition: all 0.3s ease;
  min-width: 100px;
}

::v-deep .confirm-delete-modal .btn-danger {
  background: linear-gradient(135deg, #dc3545, #c82333);
  border: none;
  box-shadow: 0 4px 15px rgba(220, 53, 69, 0.3);
}

::v-deep .confirm-delete-modal .btn-danger:hover {
  background: linear-gradient(135deg, #c82333, #bd2130);
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(220, 53, 69, 0.4);
}

::v-deep .confirm-delete-modal .btn-outline-secondary {
  border: 2px solid #6c757d;
  color: #6c757d;
  background: transparent;
}

::v-deep .confirm-delete-modal .btn-outline-secondary:hover {
  background: #6c757d;
  color: white;
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(108, 117, 125, 0.3);
}

/* 簡化版我的最愛模態框樣式 */
.simple-love-modal ::v-deep .ant-modal-header {
  background: linear-gradient(135deg, #ff6b6b, #ffa8a8);
  border-bottom: none;
  border-radius: 8px 8px 0 0;
}

.simple-love-modal ::v-deep .ant-modal-title {
  color: white;
  font-weight: 600;
  font-size: 18px;
}

.simple-love-modal ::v-deep .ant-modal-close {
  color: white;
}

.simple-love-modal ::v-deep .ant-modal-close:hover {
  color: #f0f0f0;
}

.simple-love-modal ::v-deep .ant-modal-content {
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
}

.simple-love-item {
  border: 1px solid #f0f0f0 !important;
  border-radius: 8px !important;
  margin-bottom: 8px !important;
  transition: all 0.3s ease;
  background: white;
}

.simple-love-item:hover {
  transform: translateY(-1px);
  box-shadow: 0 3px 12px rgba(0, 0, 0, 0.1);
  border-color: #ff6b6b !important;
}

.simple-love-item.deleting {
  opacity: 0.6;
  transform: scale(0.98);
}

.simple-avatar {
  border: 2px solid white;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
}

.simple-delete-btn {
  border-radius: 6px;
  border: 2px solid #ff6b6b;
  color: #ff6b6b;
  background: transparent;
  padding: 6px 10px;
  transition: all 0.2s ease;
}

.simple-delete-btn:hover {
  background: #ff6b6b;
  color: white;
  transform: scale(1.05);
}

.simple-delete-btn:focus {
  box-shadow: 0 0 0 0.2rem rgba(255, 107, 107, 0.25);
}

.simple-love-modal ::v-deep .ant-modal-footer {
  background: #f8f9fa;
  border-top: 1px solid #e9ecef;
  text-align: center;
}

</style>